import apiService from "../api/api.service";
import { CheckoutResponse, RetryPaymentResponse } from "../../types/sub.types";
// API rotaları

export interface SubscriptionStatus {
  status: "active" | "inactive" | "expired" | "trial" | "in_grace_period";
  daysLeft: number;
  userLimit: number;
  message: string;
  expiresAt: string;
  startDate: string;
  duration?: number; // Kaç aylık üyelik (3, 6, 12)
}

export interface CreateCheckoutRequest {
  plan: "monthly" | "yearly";
  userLimit: number;
  companyId: number;
}

export interface PurchasePackageRequest {
  couponCode?: string;
  referralCode?: string; // Referans kodu (yeni şirket kaydı için)
  companyId: number;
  userLimit: number;
  duration: number;
  finalAmount: number;
  billingAddress: {
    alias: string;
    address: string;
    city: string;
    district: string; // İlçe bilgisi - abonelik sona erdiğinde gönderilir
    zipCode: string;
    country: string;
    contactName: string;
  };
  isInternalRequest?: boolean;
}

export interface AddUsersRequest {
  additionalUsers: number;
  finalAmount: number;
  billingAddress?: {
    alias: string;
    address: string;
    city: string;
    zipCode: string;
    country: string;
    contactName: string;
  };
  referralRewardIds?: string[]; // Referans ödül ID'leri
  couponCode?: string; // Kupon kodu
}

export interface IyzicoCallbackRequest {
  token: string;
  conversationId: string;
}

class SubService {
  private static instance: SubService;

  private constructor() {}

  public static getInstance(): SubService {
    if (!SubService.instance) {
      SubService.instance = new SubService();
    }
    return SubService.instance;
  }

  // Private constructor

  public async createCheckoutSession(
    data: CreateCheckoutRequest
  ): Promise<CheckoutResponse> {
    const response = await apiService.post<CheckoutResponse>(
      "/sub/create-checkout-session",
      data
    );
    return response;
  }

  public async purchasePackage(
    data: PurchasePackageRequest
  ): Promise<CheckoutResponse> {
    const response = await apiService.post<CheckoutResponse>(
      "/sub/purchase-package",
      data
    );
    return response;
  }

  public async addUsers(data: AddUsersRequest): Promise<CheckoutResponse> {
    const response = await apiService.post<CheckoutResponse>(
      "/sub/add-users",
      data
    );
    return response;
  }

  public async handleIyzicoCallback(data: IyzicoCallbackRequest): Promise<any> {
    const response = await apiService.post<any>("/sub/callback", data);
    return response;
  }

  public async verifyPayment(
    token: string,
    conversationId: string,
    companyId: any
  ): Promise<any> {
    const response = await apiService.post<any>("/sub/verify-payment", {
      token,
      conversationId,
      companyId
    });
    return response;
  }

  public async retryPayment(): Promise<RetryPaymentResponse> {
    const response = await apiService.post<RetryPaymentResponse>(
      "/sub/retry-payment"
    );
    return response;
  }

  public async cancelSubscription(): Promise<{ message: string }> {
    const response = await apiService.put<{ message: string }>("/sub/cancel");
    return response;
  }

  public async getSubsByCompanyId(): Promise<SubscriptionStatus> {
    const response = await apiService.get<SubscriptionStatus>(`/sub/status`);
    return response;
    // return {
    //     status: 'in_grace_period',
    //     daysLeft: 2,
    //     userLimit: 10,
    //     message: 'In Grace Period',
    //     expiresAt: '2025-12-07',
    //     startDate: '2025-07-07',
    // };
  }
}

export default SubService.getInstance();
